import { Link } from 'react-router-dom'

export function LandingNav() {
  return (
    <nav className="border-b border-border bg-primary-bg">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          <Link to="/" className="text-lg font-medium">
            Beacon
          </Link>
          <div className="flex items-center gap-4">
            <Link
              to="/login"
              className="text-sm text-secondary-text hover:text-primary-text transition-colors"
            >
              Login
            </Link>
            <Link to="/login?tab=register" className="btn btn-primary text-sm">
              Sign Up
            </Link>
          </div>
        </div>
      </div>
    </nav>
  )
}
